import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", {

  plugins: ["InvocaApp", "ModalDialog", "Form"]

});
